import React from 'react'
import "./About.css"
import avatar from "./avatar.png"
function About() {
  return (
    <div className='about__section'>
        <div className="avatar">
          <img src={avatar} alt="" height='220px' width='220px'/>
        </div>
        <div className="description">
          <p>I am Nilutpal, a 22 old software engineer. I am currently pursuing my Bachelor's of Technology in Computer Science and Engineering from AEC,India. I love solving problems and enjoy working on projects where approaching design and development as co-dependent processes can lead to smarter solutions and a better overall product experience for fellow humans. If you have an exciting project in mind, or just wanna chat,</p>
          <a className='textt' href="mailto:nilutpalb64@gmail.com"><h3 className='lastSen'>get in touch with me here</h3></a>
        </div>
    </div>
  )
}

export default About